/*!

=========================================================
* Central System - v1.0.0
=========================================================

* Coded by Aircode

=========================================================

*/
import React, { useEffect, useState } from 'react';

// reactstrap components
import { Card, CardBody, CardTitle, Row, Col, Spinner } from "reactstrap";
// core components
import { studentBoundList, getSubscriptions } from "../../../../network/ApiAxios.js";
import secureLocalStorage from "react-secure-storage";

const KPISubscription = (props) => {
  const [isLoading, setisLoading] = useState(false)
  const [subscription, setSubscription] = useState([])
  const user = JSON.parse(secureLocalStorage.getItem("user"));
  const app = JSON.parse(secureLocalStorage.getItem("app"));

  useEffect(() => {
    const runCountSubs = async () => {
      setisLoading(true);
  
        let params = {
          filter: { account: user.account, active: true },
          constraint: { app: app._id }
        }
        const response = await getSubscriptions(params);

        if (response.data.success) {
          let countSubscriptions = 0
          let countLicenses = 0
          let countConsumed = 0          
          response?.data?.subscriptions?.map(subscription => {
            countLicenses += subscription?.licensesLimit
            countConsumed += subscription?.consumedLicenses
            countSubscriptions += 1
          })
          setSubscription({
            countLicenses: countLicenses,
            countConsumed: countConsumed,
            countSubscriptions: countSubscriptions
          })

        }

        setisLoading(false);      
    }

    runCountSubs();

  }, []);

  return (
    <>
      <Card className="card-stats mb-4 mb-xl-0">
        {
          isLoading ?
            <div className="text-center p-5">
              <Spinner size="lg" />
            </div>
            :
            <CardBody>
              <Row>
                <div className="col">
                  <CardTitle
                    tag="h6"
                    className="text-uppercase text-muted mb-0"                    
                  >
                    Subscriptions
                  </CardTitle>
                  <span className="h2 font-weight-bold mb-0">{subscription?.countSubscriptions}</span>
                </div>
                <Col className="col-auto">
                  <div className="icon icon-shape bg-green text-white rounded-circle shadow">
                    <i className="fas fa-file-contract" />
                  </div>
                </Col>
              </Row>
              <p className="mt-3 mb-0 text-muted text-sm">
                <span className="text-success mr-2">
                  {subscription?.countLicenses - subscription?.countConsumed}
                </span>{" "}
                <span className="text-nowrap">Free Licenses</span>
              </p>
              <p className="mt-3 mb-0 text-muted text-sm">
                <span className="text-success mr-2">
                  {subscription?.countConsumed}
                </span>{" "}
                <span className="text-nowrap">Consumed Licenses</span>
              </p>
              <p className="mt-3 mb-0 text-muted text-sm">
                <span className="text-success mr-2">
                  {subscription?.countLicenses}
                </span>{" "}
                <span className="text-nowrap">Total Licenses</span>
              </p>
            </CardBody>
        }
      </Card>
    </>
  );
};

export default KPISubscription;
